module.exports = __webpack_public_path__ + "static/media/tyre-red-5.e2b29594.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tyre-red-5.png
// module id = 1142
// module chunks = 0